// assets
import {
  AppstoreAddOutlined,
} from '@ant-design/icons';

// icons
const icons = {
  AppstoreAddOutlined
};

// ==============================|| MENU ITEMS - UTILITIES ||============================== //

const aiassitance = {
  id: 'ai-assistance',
  title: 'AI Assistance',
  type: 'group',
  children: [
    {
      id: 'chatbot',
      title: 'AI Chatbot',
      type: 'item',
      url: 'ai-assistance',
      icon: icons.AppstoreAddOutlined
    }
  ]
};

export default aiassitance;
